import { useQuery } from '@tanstack/react-query';

import {
  companyConfigurationService,
  CompanyConfiguration,
  useToast,
} from '@aslanpay/portal-common-lib';

const useFetchCompanyConfiguration = (companyId: string) => {
  const toast = useToast();

  return useQuery<CompanyConfiguration, Error>(
    ['fetchCompanyConfiguration', companyId],
    () => companyConfigurationService.fetchCompanyConfiguration(companyId),
    {
      enabled: !!companyId,
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: 'Sorry, we failed to fetch the company configuration. Please try again.',
        });
      },
    }
  );
};

export default useFetchCompanyConfiguration;
